import * as Three from 'three';
import React from 'react';
import { lineBreakWord } from '../../../common/functions/helperFunctions';

const WIDTH = 60;
const DEPTH = 60;
const HEIGHT = 90;

export default {
    name: 'cauldron',
    prototype: 'items',

    info: {
        tag: ['metal'],
        title: 'Cauldron',
        description: 'Cauldron',
        image: require('./cauldron.PNG')
    },

    properties: {
        altitude: {
            label: 'altitude',
            type: 'length-measure',
            defaultValue: {
                length: 0,
                unit: 'cm'
            }
        }
    },

    render2D: function (element, layer, scene) {
        let style = { stroke: 'red', strokeWidth: element.selected ? '3px' : "2px", fill: "white" };
        let width = 40;
        let depth = 35;
        let angle = element.rotation + 90;
        let textRotation = 0;
        if (Math.sin(angle * Math.PI / 180) < 0) {
            textRotation = 180;
        }
        let desc = lineBreakWord(element.desc, 20);

        return (
            <g transform={`translate(${-width / 2},${-depth / 2})`}>
                <rect key="1" x='0' y='0' width={width} height={depth} style={style} />
                <text key="2" x="0" y="0"
                    transform={`translate(${width / 2}, ${textRotation === 0 ? -5 : depth + 5}) scale(1,-1) rotate(${textRotation})`}
                    style={{ textAnchor: "middle", fontSize: "11px" }}>
                    {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                </text>

            </g>
        )
    },


    render3D: function (element, layer, scene) {
        let mesh = new Three.Mesh();
        return Promise.resolve(mesh);
    },

    renderAxonomertic: function (element, layer, scene) {
        //let angle = element.rotation + 90;
        let textRotation = 0;
        let desc = lineBreakWord(element.desc, 20);
        let style = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "white" }
        let styleRight = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "#ccc" }
        let styleFront = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "#eee" }

        // if (Math.sin(angle * Math.PI / 180) < 0) {
        //     textRotation = 180;
        // }

        return (
            // no-rotation means that the item would not be rotated in src\components\viewerAxonometric\item.jsx!
            <g transform={`translate(-40, -40)`} key='no-rotation'>
                <rect key="1" x="0" y={-HEIGHT} width={WIDTH} height={HEIGHT} style={styleFront} />
                <g transform={`scale(1, 0.5) skewX(27)`}>
                    <rect key="2" x="0" y="0" width={WIDTH} height={DEPTH} style={style} />
                </g>
                <g transform={`translate(${WIDTH}, 0) skewY(45)`}>
                    <rect key="3" x="0" y={-HEIGHT} width={WIDTH / 2} height={HEIGHT} style={styleRight} />
                </g>

                {element.productCount
                    ? <>
                        <path d={`M${WIDTH + 15} -20 L${WIDTH + 50} 20`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                        <path d={`M${WIDTH + 50} 20 L${WIDTH + 70} 20`} style={{ stroke: '#777', strokeWidth: '2px' }} />
                        <circle id="3" cx={`${WIDTH + 70}`} cy="20" r="17" style={{ stroke: '#777', fill: '#ffffff', strokeWidth: '2px' }} />
                        <text
                            x={`${WIDTH + 70}`}
                            y="-20"
                            fontFamily="Arial"
                            alignmentBaseline="middle"
                            textAnchor="middle"
                            fontSize={24}
                            fill="#000000"
                            transform={`scale(1,-1) rotate(${textRotation})`}
                        >
                            {element.productCount}
                        </text>
                    </>
                    : null}

                <line key="4" x1="0" y1={-HEIGHT + 15} x2={WIDTH} y2={-HEIGHT + 15} stroke={element.selected ? '#000' : '#777'} strokeWidth="2px" />
                <circle key="5" cx={10} cy={-HEIGHT + 7} r={3} style={style} />
                <circle key="6" cx={20} cy={-HEIGHT + 7} r={3} style={style} />
                <circle key="7" cx={30} cy={-HEIGHT + 7} r={3} style={style} />
                <circle key="8" cx={40} cy={-HEIGHT + 7} r={3} style={style} />
                <circle key="9" cx={50} cy={-HEIGHT + 7} r={3} style={style} />
                {!element.productCount
                    ? <text key="10" x="0" y="0"
                        transform={`translate(${WIDTH + 5}, ${textRotation === 0 ? -2 : DEPTH + 5}) scale(1,-1) rotate(${textRotation})`}
                        style={{ textAnchor: "left", fontSize: "11px" }}>
                        {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                    </text>
                    : null}
            </g>
        )
    }
};
